import React, { useState, useEffect } from "react";
import Layout from "../components/layout";
import AboutMainBanner from "../components/home-page/home-page-main-banner";
import AboutPartner from "../components/about-us/about-partner";
import AboutMission from "../components/about-us/about-mission";
import AboutTestimonial from "../components/about-us/about-testimonial";
import SEO from '../components/seo';
import {
  mainBannerObj
} from '../components/about-us/about-page-constants';

export default function AboutPage() {

  return (
    <Layout addBodyClass={"about-us-page-template transparent-header "}
      footerFormType="basic">
      <SEO description="Experience high-quality engineering, proven expertise, teamwork and commitment to your success with Rapidops Solutions."
        meta={[{ name: "charSet", content: "utf-8" }]}
        title="About Us - Digital Product Development Company" />
      <AboutMainBanner data={mainBannerObj} />
      <AboutPartner />
      <AboutMission />
      <AboutTestimonial />
    </Layout>
  );
};